import { AxiosRequestConfig } from 'axios';

/**
 * Represents a generic Signer.
 * @template C Configuration type
 * @template R Request Config type
 */
export abstract class Signer<C, R, T> {
  constructor(private config: C) {}

  /**
   * Gets the configuration.
   * @returns {C} configuration
   * @throws {Error} if there is not configuration set
   */
  public getConfig(): C | never {
    if (!this.config) {
      throw new Error('There is not configuration set for the Signer');
    }

    return this.config;
  }

  /**
   * Signs the request.
   * @param {AxiosRequestConfig} requestConfig
   * @param {T} credentials
   * @returns {R} signed request config
   * @throws
   */
  public abstract sign(requestConfig: AxiosRequestConfig, credentials: T): R | never;
}
